// src/components/DisList.jsx
import React, { useEffect, useState, useMemo, useRef } from 'react';
import DelBox from '../comps/DelBox';
import AppConst from "../apis/appconst";
import axios from "axios";
import jsPDF from 'jspdf';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';
import autoTable from 'jspdf-autotable';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';


const DisList = () => {
  const [formData, setFormData] = useState({
    l1: [],
    wards: [],
    doc: [],
    page_no: 0,
    from: "",
    to: "",
    search_key: "",
  });

  const [cachedList, setCachedList] = useState([]); // last successful server list

  const [finalPayment, setFinalPayment] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [duePayment, setDuePayment] = useState(0);
  const [computedDue, setComputedDue] = useState(0);
  const [payAmount, setPayAmount] = useState('');
  const [computedPaid, setComputedPaid] = useState(0);
  const [image, setImage] = useState('');
  const [ldata, setLdata] = useState(null);
  const [loading, setLoading] = useState(false);
  const searchTimer = useRef(null);
  const DEBOUNCE_MS = 400;
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [isFetchingTxns, setIsFetchingTxns] = useState(false);
function formatDate2(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;
  const day = String(date.getDate()).padStart(2, '0');
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}
  // ----------------- Helpers -----------------
  const isObj = (v) => v && typeof v === 'object' && !Array.isArray(v);
  const safeStr = (v) => (v === null || v === undefined) ? '' : String(v);
  const safeNum = (v) => {
    const n = Number(v);
    return Number.isNaN(n) ? 0 : n;
  };
  const toFixed2 = (v) => {
    const n = safeNum(v);
    return n.toFixed(2);
  };

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function parseServerDate(datetimeStr) {
    if (!datetimeStr) return null;
    const s = String(datetimeStr).trim();
    // Try ISO parse fallback
    // If it's like 'YYYY-MM-DD' or 'YYYY-MM-DDTHH:MM:SS', Date can parse in most browsers as UTC,
    // but prefer component parsing for safer local result.
    const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2}):?(\d{2})?)?/);
    if (isoMatch) {
      const y = parseInt(isoMatch[1], 10);
      const m = parseInt(isoMatch[2], 10) - 1;
      const d = parseInt(isoMatch[3], 10);
      const hh = isoMatch[4] ? parseInt(isoMatch[4], 10) : 0;
      const mm = isoMatch[5] ? parseInt(isoMatch[5], 10) : 0;
      const ss = isoMatch[6] ? parseInt(isoMatch[6], 10) : 0;
      return new Date(y, m, d, hh, mm, ss);
    }
    const dt = new Date(s);
    if (!isNaN(dt.getTime())) return dt;
    return null;
  }

  function formatDateTime12h(dateInput) {
    if (!dateInput && dateInput !== 0) return '';
    let dateObj = dateInput instanceof Date ? dateInput : parseServerDate(dateInput);
    if (!dateObj) {
      try { dateObj = new Date(dateInput); } catch { dateObj = null; }
    }
    if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) return '';
    const day = String(dateObj.getDate()).padStart(2, '0');
    const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const month = monthNames[dateObj.getMonth()];
    const year = dateObj.getFullYear();
    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours === 0 ? 12 : hours;
    const hourStr = String(hours).padStart(2, '0');
    return `${day} ${month}- ${year} ${hourStr}:${minutes} ${ampm}`;
  }

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const d = parseServerDate(dateString) || new Date(dateString);
    if (!d || isNaN(d.getTime())) return String(dateString);
    return `${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()}`;
  };

  // amount in words (simple Indian style)
  function amountInWords(amount) {
    amount = Number(amount) || 0;
    if (amount === 0) return 'zero';
    const words = [
      '', 'one','two','three','four','five','six','seven','eight','nine','ten',
      'eleven','twelve','thirteen','fourteen','fifteen','sixteen','seventeen','eighteen','nineteen'
    ];
    const tens = ['', '', 'twenty','thirty','forty','fifty','sixty','seventy','eighty','ninety'];
    function twoDigit(n) {
      if (n < 20) return words[n];
      const t = Math.floor(n/10);
      const u = n % 10;
      return tens[t] + (u ? ' ' + words[u] : '');
    }
    function threeDigit(n) {
      const h = Math.floor(n/100);
      const rem = n % 100;
      return (h ? words[h] + ' hundred' + (rem ? ' ' : '') : '') + (rem ? twoDigit(rem) : '');
    }
    let n = Math.floor(amount);
    const parts = [];
    const crore = Math.floor(n / 10000000);
    if (crore) { parts.push(threeDigit(crore) + ' crore'); n = n % 10000000; }
    const lakh = Math.floor(n / 100000);
    if (lakh) { parts.push(threeDigit(lakh) + ' lakh'); n = n % 100000; }
    const thousand = Math.floor(n / 1000);
    if (thousand) { parts.push(threeDigit(thousand) + ' thousand'); n = n % 1000; }
    if (n) parts.push(threeDigit(n));
    return parts.join(' ').replace(/\s+/g, ' ').trim();
  }

  // ----------------- small getters for UI -----------------
  function getDoctorNameById(id) {
    if (!formData.doc || !Array.isArray(formData.doc)) return '';
    const d = formData.doc.find(x => String(x.user_id) === String(id));
    return d ? (d.fname || '') : '';
  }
  function getWardNameById(id) {
    const wlist = formData.wards || [];
    const w = wlist.find(x => String(x.cat_id) === String(id));
    return w ? (w.cat_name || '') : '';
  }
  function getBedNameById(bedId) {
    const wards = formData.wards || [];
    for (let w of wards) {
      if (!w || !Array.isArray(w.beds)) continue;
      const b = w.beds.find(bd => String(bd.bed_id) === String(bedId));
      if (b) return b.bed_name || '';
    }
    return '';
  }

  // ----------------- fetch transaction history (used in several places) -----------------
  // fetch transaction history by bill id (payment_parent_bill_id)
  const fetchTransactionHistory = async (billIdOrUhid) => {
    if (!billIdOrUhid) return [];
    setIsLoading(true);
    try {
      const idToUse = String(billIdOrUhid || '').trim();
      if (!idToUse) return [];
      const endpoints = [ AppConst.GetPaymentIpdBill, AppConst.GetPaymentIpdBill2 ].filter(Boolean);
      let payments = [];
      for (const ep of endpoints) {
        try {
          const url = `${AppConst.BASE_URL + ep}/${encodeURIComponent(idToUse)}`;
          const resp = await axios.get(url);
          const payload = resp?.data || {};
          payments = payload.history || payload.records || payload.payments ||
                     Object.values(payload).find(v => Array.isArray(v) && v.length) || [];
          if (Array.isArray(payments) && payments.length) break;
        } catch (e) { /* try next endpoint */ }
      }
      setTransactionHistory(Array.isArray(payments) ? payments : []);
      return Array.isArray(payments) ? payments : [];
    } catch (error) {
      console.error('Failed to fetch transaction history', error);
      setTransactionHistory([]);
      return [];
    } finally {
      setIsLoading(false);
    }
  };
  
  


  // Recalculate computedPaid and computedDue whenever transactions, advance or final amount change
  useEffect(() => {
    const adv = Number(formData.ipd_bill_adv_amount || 0);
    const finalAmt = Number(formData.ipd_bill_final_amt || 0);
    const transSum = (transactionHistory || []).reduce((s, t) => s + (Number(t.payment_amount || t.amount || 0)), 0);
    const newPaid = adv + transSum;
    const newDue = Math.max(0, finalAmt - newPaid);
    setComputedPaid(newPaid);
    setComputedDue(newDue);
    setFormData(prev => {
      const prevPaid = Number(prev.ipd_bill_paid || 0);
      const prevDue = Number(prev.ipd_bill_due || 0);
      if (prevPaid === newPaid && prevDue === newDue) return prev;
      return { ...prev, ipd_bill_paid: newPaid, ipd_bill_due: newDue };
    });
    setDuePayment(newDue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionHistory, formData.ipd_bill_adv_amount, formData.ipd_bill_final_amt]);

  useEffect(() => {
    const uh = formData.ipd_bill_uhid;
    const billId = formData.ipd_bill_id || formData.ipd_no;
    const idToUse = uh || billId;
    if (idToUse) fetchTransactionHistory(idToUse);
    // eslint-disable-next-line
  }, [formData.ipd_bill_uhid, formData.ipd_bill_id, formData.ipd_no]);
  
  

  // ----------------- generatePDF (single consolidated version) -----------------
  const imageUrlToBase64 = async (url) => {
    if (!url) return null;
    try {
      const resp = await fetch(url);
      if (!resp.ok) return null;
      const blob = await resp.blob();
      return await new Promise((resolve, reject) => {
        const r = new FileReader();
        r.onloadend = () => resolve(r.result);
        r.onerror = reject;
        r.readAsDataURL(blob);
      });
    } catch (e) {
      console.error(e);
      return null;
    }
  };

   // Replace your generatePDF with this safe version
  // Robust generatePDF — safe: no const reassignment, guarded maps, fallback lookups
const generatePDF = async (dataParam) => {
  const data = dataParam || {}; 
  // prefer explicit arrays passed in by caller
let transactions = Array.isArray(data.transactions) ? data.transactions.slice() : [];
let otitems = Array.isArray(data.ipd_bill_items) ? data.ipd_bill_items.slice() : [];
// use local 'data' to avoid shadowing component formData
  const doc = new jsPDF();
  let y = 0;

  // helper local to fetch header image
  async function headerImgToBase64(url) {
    if (!url) return null;
    try {
      const r = await fetch(url);
      if (!r.ok) return null;
      const blob = await r.blob();
      return await new Promise((res, rej) => {
        const fr = new FileReader();
        fr.onloadend = () => res(fr.result);
        fr.onerror = rej;
        fr.readAsDataURL(blob);
      });
    } catch (e) { return null; }
  }

  try {
    const headerImageBase64 = await headerImgToBase64(image);
    if (headerImageBase64) {
      const pageWidth = doc.internal.pageSize.getWidth();
      const height = 30;
      doc.addImage(headerImageBase64, "PNG", 0, y, pageWidth, height);
    }
  } catch (err) {
    console.warn('header image error', err);
  }

  y = 38;
  const headerColor = [180, 220, 250];

  // UHID and barcode
  const uhidVal = data.ipd_bill_uhid || data.uhid || '456';
  let barcodeDataUrl = uhidVal;
  try {
    if (uhidVal) {
      const canvas = document.createElement('canvas');
      JsBarcode(canvas, String(uhidVal), {
        format: 'CODE128',
        displayValue: false,
        height: 25,
        margin: 0
      });
      barcodeDataUrl = canvas.toDataURL('image/png');
    }
  } catch (e) { console.warn('barcode err', e); }

  // Header table (patient + ipd info)
  autoTable(doc, {
    startY: y,
    body: [[
      `UHID No : ${uhidVal}\nPatient : ${data.ipd_bill_patient_name || ''}\nAge/Gender : ${data.ipd_bill_patient_age || ''} / ${data.ipd_bill_patient_gender || ''}\nAddress : ${data.ipd_bill_patient_address || ''}\nReferred Doctor : ${getDoctorNameById(data.ipd_bill_refered_doctor) || ''}`,
      `IPD No : 000${data.ipd_bill_id || data.ipd_no || ''}\nAdmission Date : ${formatDateTime12h(data.ipd_bill_doa)}\nBilling Date : ${formatDateTime12h(data.ipd_bill_date)}\nBed : ${getBedNameById(data.ipd_bill_bed) || ''}\nWard : ${getWardNameById(data.ipd_bill_ward) || ''}`
    ]],
    theme: 'grid',
    styles: { fontSize: 10, cellPadding: 2, lineColor: [0,0,0], textColor: [0,0,0], lineWidth: 0.3 },
    columnStyles: { 0: { cellWidth: 110 }, 1: { cellWidth: 70 } },
    didDrawCell: function (dt) {
      try {
        if (dt.section === 'body' && dt.column.index === 0 && dt.row.index === 0 && barcodeDataUrl) {
          const cell = dt.cell;
          const imgW = 34, imgH = 7;
          const imgX = cell.x + 73;
          const imgY = cell.y + 2;
          doc.addImage(barcodeDataUrl, 'PNG', imgX, imgY, imgW, imgH);
        }
      } catch (e) { console.warn('didDrawCell addImage', e); }
    }
  });

  y = doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 2 : y + 40;

  // Lab details (uses component state finalPayment safely)
  doc.setFontSize(10).setFont('helvetica', 'bold');
  autoTable(doc, {
    startY: y + 3,
    head: [['Lab Details']],
    body: [[{ content: `Total Price: ${Number(finalPayment || 0).toFixed(2)}`, styles: { halign: 'left' } }]],
    theme: 'grid', // ✅ gives visible borders
    headStyles: {
      fillColor: headerColor,
      textColor: [0, 0, 0], // black text
      fontStyle: 'bold',
      halign: 'left',
      lineColor: [0, 0, 0],
      lineWidth: 0
    },
    bodyStyles: {
      textColor: [0, 0, 0], // black text
      lineColor: [0, 0, 0],
      lineWidth: 0
    },
    styles: {
      fontSize: 9,
      cellPadding: 1.5,
      textColor: [0, 0, 0],
      lineColor: [0, 0, 0],
      lineWidth: 0
    },
    didDrawCell: (data) => {
      try {
        const cell = data.cell;
        doc.setDrawColor(0);  // black
        doc.setLineWidth(0); // thin line (hairline look)
        doc.rect(cell.x, cell.y, cell.width, cell.height); // manually reinforce borders
      } catch (e) {}
    }
  });
  



  y = doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 2 : y + 20;

  // Pharmacy stub
  doc.setFontSize(10).setFont('helvetica', 'bold');
  autoTable(doc, {
    startY: y + 3,
    head: [['Pharmacy Details']],
    body: [[{ content: `Total Price: 0.00`, styles: { halign: 'left' } }]],
    theme: 'grid', // ✅ use grid for visible black borders
    headStyles: {
      fillColor: headerColor,
      textColor: [0, 0, 0],   // black header text
      fontStyle: 'bold',
      halign: 'left',
      lineColor: [0, 0, 0],   // black border
      lineWidth: 0         // thin border
    },
    bodyStyles: {
      textColor: [0, 0, 0],   // black body text
      lineColor: [0, 0, 0],
      lineWidth: 0
    },
    styles: {
      fontSize: 9,
      cellPadding: 1.5,
      textColor: [0, 0, 0],   // fallback black text
      lineColor: [0, 0, 0],
      lineWidth: 0
    },
    didDrawCell: (data) => {
      try {
        const cell = data.cell;
        doc.setDrawColor(0);  // black
        doc.setLineWidth(0); // thin line (hairline look)
        doc.rect(cell.x, cell.y, cell.width, cell.height); // manually reinforce borders
      } catch (e) {}
    }
  });
  


  y = doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 6 : y + 30;




  
  // Transactions: robust detection and safe default
  // ---------------- Transactions detection + fetch fallback ----------------
// ---------------- Transactions detection + fetch fallback (REPLACE EXISTING BLOCK) ----------------
// ----- BEGIN REPLACE: robust server fetch + transaction selection -----
console.debug("generatePDF called with data:", data);
console.debug("component transactionHistory state length:", Array.isArray(transactionHistory) ? transactionHistory.length : 0);

const getByPath = (obj, path) => {
  if (!obj) return undefined;
  return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
};
// if caller supplied transactions explicitly, use them immediately
if (transactions.length === 0 && Array.isArray(data.transactions) && data.transactions.length) {
  transactions = data.transactions;
}

const candidateTxPaths = [
  'transactionHistory','transactions','payments','ipd_payments','payment_history',
  'txn','txns','payments_list','paymentsHistory','transactions_list','history','records'
];

//let transactions = [];

// 1) try candidate paths on passed-in data (and parse JSON strings)
for (const p of candidateTxPaths) {
  const v = getByPath(data, p);
  if (Array.isArray(v) && v.length) { transactions = v; console.debug('transactions found at data.'+p); break; }
  if (typeof v === 'string') {
    try {
      const parsed = JSON.parse(v);
      if (Array.isArray(parsed) && parsed.length) { transactions = parsed; console.debug('transactions parsed JSON at data.'+p); break; }
      if (parsed && Array.isArray(parsed.items) && parsed.items.length) { transactions = parsed.items; console.debug('transactions parsed JSON.items at data.'+p); break; }
    } catch (e) { /* ignore parse error */ }
  }
}

// 2) fallback: scan top-level arrays in data for transaction-like objects
if (!transactions.length) {
  for (const k of Object.keys(data || {})) {
    if (Array.isArray(data[k]) && data[k].length) {
      const looksLikeTxn = data[k].some(it => it && (it.payment_amount !== undefined || it.amount !== undefined || it.payment_method !== undefined || it.paid_amount !== undefined));
      if (looksLikeTxn) { transactions = data[k]; console.debug('transactions found at data.'+k+' (scanned top-level)'); break; }
    }
  }
}

// 3) fallback: use component state transactionHistory
if (!transactions.length && Array.isArray(transactionHistory) && transactionHistory.length) {
  transactions = transactionHistory;
  console.debug('transactions taken from component state transactionHistory');
}

// 4) last resort: fetch from server using id/uhid if available and we still have no transactions
// --- fetch payments for this bill id (prefer numeric bill id) ---
// --- FETCH payments for this bill id (preferred) ---
// --- BEGIN: fetch payments for this bill (preferred) ---
// inside generatePDF, replace the fetch-by-id code with this:
// prefer single canonical endpoint; try fallback if first returns empty
const tryFetchPayments = async (id) => {
  const endpoints = [
    AppConst.GetPaymentIpdBill2, // primary used in your generatePDF
    //AppConst.GetPaymentIpdBill   // fallback used elsewhere
  ];
  for (const ep of endpoints) {
    if (!ep) continue;
    try {
      const url = `${AppConst.BASE_URL + ep}/${id}`;
      console.debug('Trying payments endpoint:', url);
      const resp = await axios.get(url);
      console.debug('payments resp for', ep, resp?.data);
      if (resp && resp.data) {
        // prefer resp.data.history, then records, payments, etc.
        const arr = resp.data.history || resp.data.records || resp.data.payments ||
                    resp.data.items || resp.data.transactions ||
                    Object.values(resp.data).find(v => Array.isArray(v) && v.length);
        if (Array.isArray(arr) && arr.length) return arr;
      }
    } catch (err) {
      console.warn('payments fetch err for', ep, err && (err.message || err));
    }
  }
  return [];
};

// prefer UHID, then id/no
const idToUse = (data && (data.ipd_bill_uhid || data.ipd_bill_uhid === 0)) 
                ? String(data.ipd_bill_uhid).trim()
                : (data.ipd_bill_id || data.ipd_no || '');

if (!transactions.length && idToUse) {
  setIsFetchingTxns(true);
  try {
    console.debug('generatePDF: fetching payment history for id/uhid =', idToUse);
    // prefer the endpoint that worked in browser: AppConst.GetPaymentIpdBill
    const endpoints = [AppConst.GetPaymentIpdBill, AppConst.GetPaymentIpdBill2].filter(Boolean);
    for (const ep of endpoints) {
      try {
        const resp = await axios.get(`${AppConst.BASE_URL + ep}/${encodeURIComponent(idToUse)}`);
        console.debug('generatePDF: payments response for', ep, resp?.data);
        if (resp && resp.data) {
          if (Array.isArray(resp.data.history) && resp.data.history.length) {
            transactions = resp.data.history;
            break;
          } else if (Array.isArray(resp.data.records) && resp.data.records.length) {
            transactions = resp.data.records;
            break;
          } else if (Array.isArray(resp.data.payments) && resp.data.payments.length) {
            transactions = resp.data.payments;
            break;
          } else {
            // find first array value
            for (const k of Object.keys(resp.data)) {
              if (Array.isArray(resp.data[k]) && resp.data[k].length) {
                transactions = resp.data[k];
                break;
              }
            }
            if (transactions.length) break;
          }
        }
      } catch (err) {
        console.warn('generatePDF: fetch payments failed for', ep, err && err.message);
      }
    }

    if (Array.isArray(transactions) && transactions.length) {
      setTransactionHistory(transactions);
      console.debug('generatePDF: transactions fetched count=', transactions.length);
    } else {
      console.debug('generatePDF: server returned no transactions (empty history). idToUse=', idToUse);
    }
  } catch (err) {
    console.warn('generatePDF: error fetching payment history', err);
  } finally {
    setIsFetchingTxns(false);
  }
}



// --- END ---



// ensure array
if (!Array.isArray(transactions)) transactions = [];

// Build txnBody safely (used for autoTable)
const txnBody = transactions.length ? transactions.map((t, idx) => {
  const dt = formatDate(t.payment_datetime || t.payment_date || t.payment_time || t.created_at || t.datetime || '');
  const amount = (Number(t.payment_amount || t.amount || t.amt || t.paid_amount || 0)).toFixed(2);
  const method = t.payment_method || t.payment_type || t.method || t.mode || 'N/A';
  const receivedBy = t.received_by_name || t.collected_by || t.collected_by_name || (`User #${t.received_by || t.collected_by || ''}`);
  return [ idx + 1, dt, amount, method, receivedBy ];
}) : [['', 'No Record Found', '', '', '']];

console.debug('generatePDF: final txnBody length =', txnBody.length);
// ----- END REPLACE -----



// Now pass txnBody to autoTable as before
doc.setFontSize(10).setFont('helvetica', 'bold');
  doc.text("IPD Payment History", 14, y);

  autoTable(doc, {
    startY: y + 2,
    head: [['Sl.No', 'Date', 'Amount', 'Payment Method', 'Received By']],
    body: txnBody,
    theme: 'grid',
    headStyles: {
      fillColor: headerColor,
      textColor: [0, 0, 0],
      fontStyle: 'bold',
      lineColor: [0, 0, 0],
      lineWidth: 0
    },
    styles: {
      fontSize: 9,
      cellPadding: 1.5,
      textColor: [0, 0, 0],
      lineColor: [0, 0, 0],
      lineWidth: 0
    },
    // optional: ensure cell borders are drawn even on older/tweaky versions
    didDrawCell: (data) => {
      try {
        const cell = data.cell;
        // draw a clean black rectangle border around each cell
        doc.setDrawColor(0); // black
        doc.setLineWidth(0);
        doc.rect(cell.x, cell.y, cell.width, cell.height);
      } catch (e) { /* ignore drawing errors */ }
    }
  });
  


  y = doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 9 : y + 50;





  // Items detection (robust candidate paths)
  const candidateItemPaths = ['otitems','ot_items','items','bill_items','ipd_bill_items','post_bill_items','rows','services','line_items','items_detail','bill_details.items','bill_details','billing','billing.items','billing.line_items','bill.items','post.bill.items','final_bill.items','items_json','bill_items_json','line_items_json','service_json'];
  //let otitems = [];

  for (const p of candidateItemPaths) {
    const v = getByPath(data, p);
    if (Array.isArray(v) && v.length) { otitems = v; break; }
    if (typeof v === 'string') {
      try {
        const parsed = JSON.parse(v);
        if (Array.isArray(parsed) && parsed.length) { otitems = parsed; break; }
        if (parsed && Array.isArray(parsed.items) && parsed.items.length) { otitems = parsed.items; break; }
      } catch (e) { /* ignore */ }
    }
  }

  if (!otitems.length) {
    for (const k of Object.keys(data || {})) {
      if (Array.isArray(data[k]) && data[k].length) {
        const looksLikeItem = data[k].some(it => it && (it.ipd_bill_item_service !== undefined || it.ipd_bill_item_final !== undefined || it.service !== undefined || it.name !== undefined));
        if (looksLikeItem) { otitems = data[k]; break; }
      }
    }
  }

  // if (!otitems.length && Array.isArray(formData.otitems) && formData.otitems.length) {
  //   otitems = formData.otitems;
  // }

  if (!Array.isArray(otitems)) otitems = [];

  // IPD items table
  doc.setFontSize(10).setFont('helvetica', 'bold');
  doc.text("IPD Billing Details", 14, y);

   // IPD items table (no Date column; add Discount after Price)
   
 
   const ipdRows = otitems.length ? otitems.map((it, idx) => {
    const name = it.ipd_bill_item_service || it.service || it.name || it.title || 'N/A';
    const qty = Number(it.ipd_bill_item_qty ?? it.qty ?? it.quantity ?? 1) || 1;
    const price = Number(it.ipd_bill_item_charge ?? it.charge ?? it.price ?? it.rate ?? 0) || 0;
    const discount = Number(it.ipd_bill_item_dis ?? it.discount ?? it.disc ?? 0) || 0;
    const amt = Number(it.ipd_bill_item_final ?? it.amount ?? it.line_total ?? (price * qty) - discount) || 0;
    return [idx + 1, name, qty, price.toFixed(2), discount.toFixed(2), amt.toFixed(2)];
  }) : [['', 'No items', '', '', '', '']];
  
 
   autoTable(doc, {
    startY: y + 2,
    head: [['S.No', 'Particular of Services', 'Qty', 'Price', 'Discount', 'Amount']],
    body: ipdRows,
    theme: 'grid',
    headStyles: {
      fillColor: headerColor,
      textColor: [0, 0, 0],   // black text in header
      fontStyle: 'bold',
      lineColor: [0, 0, 0],
      lineWidth: 0          // thin border
    },
    bodyStyles: {
      textColor: [0, 0, 0],   // black text in table body
      lineColor: [0, 0, 0],
      lineWidth: 0
    },
    styles: {
      fontSize: 9,
      cellPadding: 1.5,
      textColor: [0, 0, 0],   // fallback (ensures black text globally)
      lineColor: [0, 0, 0],
      lineWidth: 0
    },
    columnStyles: {
      0: { halign: 'center' },
      2: { halign: 'center' },
      3: { halign: 'right' },
      4: { halign: 'right' },
      5: { halign: 'right' }
    },
    didDrawCell: (data) => {
      try {
        const cell = data.cell;
        doc.setDrawColor(0);  // black
        doc.setLineWidth(0); // hairline-thin border
        doc.rect(cell.x, cell.y, cell.width, cell.height);
      } catch (e) { /* ignore */ }
    }
  });
  
 


  y = doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 8 : y + 40;

  // Summary numbers (safe)
  const total = Number(data.ipd_bill_total_amt || data.total || data.grand_total || 0);
  const discountPercent = Number(data.ipd_bill_discount || data.discount || 0);
  const discountAmount = Number(data.ipd_bill_fixed_deposit || 0) || (total * discountPercent / 100);
  const finalAmt = Number(data.ipd_bill_final_amt || data.final_amount || 0);
  const adv = Number(data.ipd_bill_adv_amount || data.advance || 0);
  const due = Math.max(0, Number(data.ipd_bill_due ?? data.due ?? 0));

  const paid = Number(data.ipd_bill_paid || data.paid || 0);

  const labelX = 140, rightX = 190;
  doc.setFontSize(10).setFont('helvetica', 'normal');
  doc.text("Total Amount :", labelX, y); doc.text(total.toFixed(2), rightX, y, { align: 'right' }); y += 6;
  doc.text("Discount Amt :", labelX, y); doc.text(discountAmount.toFixed(2), rightX, y, { align: 'right' }); y += 6;
  doc.text("Final Amount :", labelX, y); doc.text(finalAmt.toFixed(2), rightX, y, { align: 'right' }); y += 6;
  doc.text("Advance :", labelX, y); doc.text(adv.toFixed(2), rightX, y, { align: 'right' }); y += 6;
  doc.text("Due :", labelX, y); doc.text(due.toFixed(2), rightX, y, { align: 'right' }); y += 6;
  doc.text("Paid :", labelX, y); doc.text(paid.toFixed(2), rightX, y, { align: 'right' }); y += 10;

  doc.setFontSize(9).setFont('helvetica', 'bold');
  const finalAmountInWords = amountInWords(finalAmt || 0) + ' only';
  doc.text(`AMOUNT IN WORDS : ${finalAmountInWords.toUpperCase()}`, 14, y);

  const footerY = y + 20;
  const qrText = `UHID: ${data.ipd_bill_uhid || ''}, Name: ${data.ipd_bill_patient_name || ''}`;
  try {
    const qrCodeDataURL = await QRCode.toDataURL(qrText, { width: 100 });
    doc.addImage(qrCodeDataURL, "PNG", 14, footerY, 19, 19);
  } catch (e) { /* ignore */ }

 // Use the transactions we used to build the IPD Payment History table.
// If localTransactions is empty, fall back to component state transactionHistory.
// Use the same 'transactions' used for the IPD Payment History table,
// otherwise fall back to the component transactionHistory state.
const preparedByList = (Array.isArray(transactions) && transactions.length)
  ? transactions
  : (Array.isArray(transactionHistory) && transactionHistory.length ? transactionHistory : []);

if (!preparedByList.length) {
  console.debug('generatePDF: no prepared-by records found (transactions and transactionHistory are empty).');
}

preparedByList.forEach(item => {
  const name = (item.received_by_name && item.received_by_name.trim() !== '')
    ? item.received_by_name
    : ('User #' + (item.received_by || item.collected_by || ''));
  doc.text(`Prepared By: ${name}`, 14, footerY + 25);
});



  const pageWidth = doc.internal.pageSize.getWidth();
  doc.setFontSize(9).setFont('helvetica', 'bold');
  doc.text("Authorised Signature", pageWidth - 50, footerY + 25);
  doc.line(pageWidth - 70, footerY + 20, pageWidth - 15, footerY + 20);

  const pdfBlobUrl = doc.output('bloburl');
  window.open(pdfBlobUrl, '_blank');
};



  // ----------------- other PDF variants kept but simplified -----------------
  const generateProvisionalBill = async (formDataLocal) => {
    // Keep your existing provisional PDF logic; for brevity call the same generatePDF if you want.
    // Here we'll create a simple provisional by reusing generatePDF (you can replace with your more complex implementation)
    await generatePDF(formDataLocal);
  };

  const generateGatePass = (item) => {
    const win = window.open('', '_blank', 'width=800,height=900');
    if (!win) {
      Swal.fire("Popup blocked", "Please allow popups to print the gate pass.", "warning");
      return;
    }
  
    // safe bed/ward lookup: prefer ward list lookup, then fallback to item fields
    const bedName = getBedNameById(item.ipd_bill_bed) || item.bed_name || item.ipd_bill_bed || '';
    const wardName = getWardNameById(item.ipd_bill_ward) || item.ward_name || item.ipd_bill_ward || '';
  
    const html = `
      <html>
      <head><title>Gate Pass - ${escapeHtml(item.ipd_bill_patient_name || '')}</title>
      <style>
        body { font-family: Arial, sans-serif; padding: 20px; color: #222; }
        .card { border: 1px solid #ddd; padding: 18px; border-radius: 6px; max-width:700px; }
        h1 { font-size: 20px; margin-bottom: 6px; }
        .row { display:flex; gap:12px; margin-bottom:8px; align-items:center; }
        .label { font-weight:600; width:150px; }
        .value { flex:1; word-break:break-word; }
        .note { margin-top:18px; font-size:12px; color:#666;}
        .small { font-size:13px; color:#333; }
      </style>
      </head>
      <body>
      <div class="card">
        <h1>Gate Pass</h1>
        <div class="row"><div class="label">Patient Name:</div><div class="value">${escapeHtml(item.ipd_bill_patient_name || '')}</div></div>
        <div class="row"><div class="label">UHID</div><div class="value">${escapeHtml(item.ipd_bill_uhid || item.ipd_no || '')}</div></div>
        <div class="row"><div class="label">IPD No</div><div class="value">000${escapeHtml(item.ipd_no || '')}</div></div>
        <div class="row"><div class="label">Bed:</div><div class="value">${escapeHtml(bedName)}</div></div>
        <div class="row"><div class="label">Ward:</div><div class="value">${escapeHtml(wardName)}</div></div>
        <div class="row"><div class="label">Final Bill:</div><div class="value">₹${Number(item.ipd_bill_final_amt || item.lab_final_amount || 0).toFixed(2)}</div></div>
        <div class="row"><div class="label">Paid:</div><div class="value">₹${Number(item.ipd_bill_paid || item.ipd_paid || 0).toFixed(2)}</div></div>
        <div class="row"><div class="label">Due:</div><div class="value">₹${Number(item.ipd_bill_due || item.ipd_due || 0).toFixed(2)}</div></div>
        <div class="note printed-at small">Printed at: ${new Date().toLocaleString()}</div>
      </div>
      <script>
        // auto-print and close optional
        setTimeout(()=>{ window.print(); }, 300);
      </script>
      </body></html>
    `;
    win.document.open();
    win.document.write(html);
    win.document.close();
  };
  

  // ----------------- data fetch/init logic -----------------


  
  const initData = async (overrides = {}) => {
    // keep stored info
    const stored = sessionStorage.getItem("ldata");
    if (stored) {
      try { setLdata(JSON.parse(stored)); } catch { /* ignore */ }
    }

    const page_no = overrides.page_no !== undefined ? overrides.page_no : formData.page_no;
    const search_key = (overrides.search_key !== undefined) ? overrides.search_key : formData.search_key;
    const from = (overrides.from !== undefined) ? overrides.from : formData.from;
    const to = (overrides.to !== undefined) ? overrides.to : formData.to;

    const effectiveFrom = from && String(from).trim() !== '' ? from : getTodayStr();
    const effectiveTo   = to && String(to).trim() !== '' ? to : getTodayStr();

    const fd = new FormData();
    fd.append('page_no', String(page_no));
    fd.append('search_key', String(search_key));
    if (effectiveFrom) fd.append('from', effectiveFrom);
    if (effectiveTo) fd.append('to', effectiveTo);
    fd.append('status', '1');

    setLoading(true);
    try {
      const res = await axios.post(AppConst.BASE_URL + AppConst.getIpdBillListUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      // success + array records -> use them
      if (res && res.data && res.data.status && Array.isArray(res.data.records)) {
        const records = res.data.records || [];
        setFormData(prev => ({ ...prev, l1: records, page_no: page_no, search_key: search_key }));
        setCachedList(records); // update cached server list
        return;
      }

      // server returned no array records
      if (search_key && String(search_key).trim() !== '') {
        // fallback: use cachedList to produce a filtered client-side list so UHID/name matches remain visible
        const fallback = filterClientBySearch(cachedList.length ? cachedList : (formData.l1 || []), search_key, effectiveFrom, effectiveTo);
        if (fallback && fallback.length) {
          setFormData(prev => ({ ...prev, l1: fallback, page_no: page_no, search_key: search_key }));
          return;
        }
        // if fallback empty, DO NOT clear the list abruptly; keep existing formData.l1
        setFormData(prev => ({ ...prev, page_no: page_no, search_key: search_key }));
        return;
      }

      // no search key -> safe to clear list (server says empty)
      setFormData(prev => ({ ...prev, l1: [] , page_no: page_no, search_key: search_key }));
    } catch (err) {
      console.error("initData error", err);
      toast.error("Error fetching list");
      // on network error, keep existing list to avoid flicker
    } finally {
      setLoading(false);
    }
  };


  const initStaticData = async () => {
    // wards
    const fdW = new FormData();
    fdW.append('par_by', '1');
    try {
      const r = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl1, fdW, { headers: { 'Content-Type': 'multipart/form-data' }});
      if (r?.data?.status) setFormData(prev => ({ ...prev, wards: r.data.records || [] }));
    } catch (e) { console.error(e); }

    // doctors
    const fdD = new FormData();
    fdD.append('type', 'doctor');
    fdD.append('search_key', '');
    fdD.append('page_no', 'none');
    fdD.append('user_cre_by', '1');
    try {
      const r2 = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fdD, { headers: { 'Content-Type': 'multipart/form-data' }});
      if (r2?.data?.status) setFormData(prev => ({ ...prev, doc: r2.data.records || [] }));
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    const stored = sessionStorage.getItem("ldata");
    if (stored) setLdata(JSON.parse(stored));
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const todayStr = `${yyyy}-${mm}-${dd}`;
    setFormData(prev => ({ ...prev, from: todayStr, to: todayStr }));
    initData({ from: todayStr, to: todayStr });
    initStaticData();
    fetchConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (formData.from === "" && formData.to === "") {
      const t = getTodayStr();
      initData({ from: t, to: t });
    } else {
      initData({ from: formData.from, to: formData.to, search_key: formData.search_key });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.from, formData.to]);


  const fetchConfig = async () => {
    try {
      const res = await axios.post(`${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`);
      if (res?.data?.status) {
        setImage(res.data.header_logo || '');
      }
    } catch (e) {
      console.error(e);
    }
  };

  // ----------------- search handlers -----------------
    // Use getTodayStr() helper (already in your file)



    const handleSearchInputChange = (value) => {
      setFormData(prev => {
        const newState = { ...prev, search_key: value };
        if (searchTimer.current) {
          clearTimeout(searchTimer.current);
          searchTimer.current = null;
        }
        const fromVal = newState.from && newState.from !== '' ? newState.from : getTodayStr();
        const toVal = newState.to && newState.to !== '' ? newState.to : getTodayStr();
  
        // quick client-side update from cachedList for immediate UX
        if (value && value.trim() !== '') {
          const quick = filterClientBySearch(cachedList.length ? cachedList : (prev.l1 || []), value, fromVal, toVal);
          if (quick && quick.length) {
            // set immediate visible list so user sees match before server responds
            newState.l1 = quick;
          }
        }
  
        // debounced server call (authoritative)
        searchTimer.current = setTimeout(() => {
          initData({ from: fromVal, to: toVal, search_key: value, page_no: 0 });
          searchTimer.current = null;
        }, DEBOUNCE_MS);
  
        return newState;
      });
    };
  
      const doImmediateSearch = () => {
    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
      searchTimer.current = null;
    }
    setFormData(prev => {
      const fromVal = prev.from && prev.from !== '' ? prev.from : getTodayStr();
      const toVal = prev.to && prev.to !== '' ? prev.to : getTodayStr();
      initData({ from: fromVal, to: toVal, search_key: prev.search_key || '', page_no: 0 });
      return prev;
    });
  };

  

  useEffect(() => () => {
    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
      searchTimer.current = null;
    }
  }, []);

  const handleSearch = () => initData({ from: formData.from, to: formData.to, search_key: formData.search_key, page_no: 0 });

  const handleClear = () => {
    if (searchTimer.current) { clearTimeout(searchTimer.current); searchTimer.current = null; }

    // compute today's date string locally to avoid "todayStr is not defined" errors
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const todayStr = `${yyyy}-${mm}-${dd}`;

    setFormData(prev => ({ ...prev, search_key: "", from: todayStr, to: todayStr, page_no: 0 }));
    initData({ from: todayStr, to: todayStr, search_key: "" });
  };
    // helper to return YYYY-MM-DD for today
    const getTodayStr = () => {
      const t = new Date();
      return `${t.getFullYear()}-${String(t.getMonth()+1).padStart(2,'0')}-${String(t.getDate()).padStart(2,'0')}`;
    };
  
    const filterClientBySearch = (list, searchKey, fromStr, toStr) => {
      const rawQ = (searchKey || '').toString().trim().toLowerCase();
      const norm = (s) => (s === null || s === undefined) ? '' : String(s).toLowerCase().replace(/[^a-z0-9]/g, '');
      const numericFromQ = (rawQ.match(/\d+/) || [''])[0];
  
      let fromDt = null, toDt = null;
      if (fromStr) {
        const p = fromStr.split('-');
        fromDt = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
      }
      if (toStr) {
        const p = toStr.split('-');
        toDt = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]), 23, 59, 59);
      }
  
      return (list || []).filter(row => {
        const s = row.status ?? row.ipd_status ?? row.ipd_bill_status ?? row.bill_status ?? null;
        if (s === null || String(s) !== '1') return false;
  
        // date filter
        const raw = row.ipd_row?.discharge_datetime ?? row.ipd_bill_ot ?? row.ipd_bill_datetime ?? row.ipd_bill_date ?? null;
        const dt = parseServerDate(raw);
        if (fromDt && toDt) {
          if (!dt || isNaN(dt.getTime())) return false;
          if (dt.getTime() < fromDt.getTime() || dt.getTime() > toDt.getTime()) return false;
        }
  
        if (!rawQ) return true; // include when search empty
  
        const qNorm = norm(rawQ);
        const uhidRaw = norm(row.ipd_bill_uhid || '');
        const ipdNo = row.ipd_no !== undefined && row.ipd_no !== null ? String(row.ipd_no) : '';
        const ipdNoNorm = norm(ipdNo);
        const paddedIpdNo = ipdNo ? ipdNo.padStart(3, '0') : '';
        const paddedIpdNoNorm = norm(paddedIpdNo);
        const nameNorm = norm(row.ipd_bill_patient_name || '');
  
        const anyMatch =
          (uhidRaw && uhidRaw.includes(qNorm)) ||
          (ipdNoNorm && (ipdNoNorm === qNorm || ipdNoNorm.includes(qNorm))) ||
          (paddedIpdNoNorm && (paddedIpdNoNorm === qNorm || paddedIpdNoNorm.includes(qNorm))) ||
          (numericFromQ && ipdNo && ipdNo === numericFromQ) ||
          (nameNorm && nameNorm.includes(qNorm));
  
        return Boolean(anyMatch);
      });
    };
  
    const filteredRows = useMemo(() => {
      const list = formData.l1 || [];
      const fromStr = formData.from || '';
      const toStr = formData.to || '';
      const rawQ = (formData.search_key || '').toString().trim().toLowerCase();
  
      // helper normalizer: remove non-alphanum and lowercase
      const norm = (s) => (s === null || s === undefined) ? '' : String(s).toLowerCase().replace(/[^a-z0-9]/g, '');
  
      // try to parse numeric part from query (useful for ipd_no)
      const numericFromQ = (rawQ.match(/\d+/) || [''])[0];
  
      let fromDt = null, toDt = null;
      if (fromStr) {
        const p = fromStr.split('-');
        fromDt = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
      }
      if (toStr) {
        const p = toStr.split('-');
        toDt = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]), 23, 59, 59);
      }
  
      return list.filter(row => {
        const s = row.status ?? row.ipd_status ?? row.ipd_bill_status ?? row.bill_status ?? null;
        if (s === null || String(s) !== '1') return false;
  
        // Date filter
        const raw = row.ipd_row?.discharge_datetime ?? row.ipd_bill_ot ?? row.ipd_bill_datetime ?? row.ipd_bill_date ?? null;
        const dt = parseServerDate(raw);
        if (fromDt && toDt) {
          if (!dt || isNaN(dt.getTime())) return false;
          if (dt.getTime() < fromDt.getTime() || dt.getTime() > toDt.getTime()) return false;
        }
  
        // Search: if empty, include
        if (!rawQ) return true;
  
        const qNorm = norm(rawQ);
        const uhidRaw = norm(row.ipd_bill_uhid || '');
        const ipdNo = row.ipd_no !== undefined && row.ipd_no !== null ? String(row.ipd_no) : '';
        const ipdNoNorm = norm(ipdNo);
        // padded ipd no with three leading zeros used in UI (e.g. 00012)
        const paddedIpdNo = ipdNo ? ipdNo.padStart(3, '0') : '';
        const paddedIpdNoNorm = norm(paddedIpdNo);
        // variants to compare
        const nameNorm = norm(row.ipd_bill_patient_name || '');
        const anyMatch =
          (uhidRaw && uhidRaw.includes(qNorm)) ||
          (ipdNoNorm && (ipdNoNorm === qNorm || ipdNoNorm.includes(qNorm))) ||
          (paddedIpdNoNorm && (paddedIpdNoNorm === qNorm || paddedIpdNoNorm.includes(qNorm))) ||
          (numericFromQ && ipdNo && ipdNo === numericFromQ) || // if user typed only digits
          (nameNorm && nameNorm.includes(qNorm));
  
        return Boolean(anyMatch);
      });
    }, [formData.l1, formData.from, formData.to, formData.search_key]);
  


  // ----------------- move to IPD -----------------
  const handleMoveToIpd = async (row) => {
    const { value: reason } = await Swal.fire({
      title: 'Move to IPD',
      text: 'Move this bill back to IPD (activate)?',
      input: 'text',
      inputLabel: 'Reason (optional)',
      inputPlaceholder: 'Enter reason (optional)',
      showCancelButton: true,
      confirmButtonText: 'Yes, move to IPD',
      cancelButtonText: 'Cancel'
    });
    if (reason === undefined) return;
    const fd = new FormData();
    if (row.ipd_bill_id) fd.append('ipd_bill_id', String(row.ipd_bill_id));
    if (row.ipd_bill_uhid) fd.append('ipd_bill_uhid', String(row.ipd_bill_uhid));
    fd.append('status', '0');
    fd.append('reason', (reason || '') + '');
    try {
      const res = await axios.post(AppConst.BASE_URL + AppConst.UpdateIpdStatusBoth2, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (!(res?.data?.status)) {
        Swal.fire('Error', (res.data && res.data.success) || 'Failed to update status', 'error');
        return;
      }
      // remove from displayed list
      setFormData(prev => ({ ...prev, l1: (prev.l1 || []).filter(r => String(r.ipd_bill_id) !== String(row.ipd_bill_id)) }));
      toast.success(res.data.success || 'Moved to IPD');
    } catch (err) {
      console.error('Move to IPD error', err);
      const isNetworkError = !err.response;
      if (isNetworkError) Swal.fire('Error', 'Server error while updating status', 'error');
      else Swal.fire('Error', (err.response?.data?.success) || 'Failed to update status', 'error');
    }
  };

  // ----------------- DataTable columns -----------------
  const columns = useMemo(() => [
    { name: 'SN', selector: (row, i) => i+1, width: '60px' },
    { name: 'UHID', selector: row => row.ipd_bill_uhid || '' , sortable: true, width: '150px' },
    {
      name: 'IPD No',
      selector: row => row.ipd_no || '',
      cell: row => `000${row.ipd_no || ''}`,
      sortable: true,
      width: '100px'
    },
    { name: 'Patient', selector: row => row.ipd_bill_patient_name || '', sortable: true, width: '200px' },
    { name: 'Bed', selector: row => getBedNameById(row.ipd_bill_bed) || 'N/A' },
    { name: 'Referred By', selector: row => getDoctorNameById(row.ipd_bill_refered_doctor) || '', width: '230px' },
    { name: 'Contact', selector: row => row.ipd_bill_patient_phone || '' , width: '150px'},
    {
      name: 'Admission Date',
      selector: row => {
        const dt = parseServerDate(row.ipd_bill_doa);
        return dt ? dt.getTime() : 0;
      },
      cell: row => {
        const dt = parseServerDate(row.ipd_bill_doa);
        return dt ? formatDateTime12h(dt) : '';
      },
      sortable: true,
      width: '200px'
    },
    {
      name: 'Discharge Date/Time',
      selector: row => {
        const dtRaw = row.ipd_row?.discharge_datetime ?? row.ipd_bill_ot ?? row.ipd_bill_datetime ?? null;
        const dt = parseServerDate(dtRaw);
        return dt ? dt.getTime() : 0;
      },
      cell: row => {
        const dt = parseServerDate(row.ipd_row?.discharge_datetime ?? row.ipd_bill_ot ?? row.ipd_bill_datetime ?? null);
        return dt ? formatDateTime12h(dt) : '';
      },
      sortable: true,
      width: '200px'
    },
    {
      name: 'Action',
      cell: row => (
        <div className="d-flex gap-2">
         
         <button
  className="btn btn-sm btn-dark"
  onClick={async () => {
    try {
      // Prefer UHID, fallback to ipd_bill_id/ipd_no
      const idToUse = row.ipd_bill_uhid || row.ipd_bill_id || row.ipd_no || '';
      // fetchTransactionHistory now returns the payments array
      const payments = idToUse ? await fetchTransactionHistory(idToUse) : [];
      
      // prepare explicit items/transactions shape so generatePDF doesn't need to guess
      const enriched = {
        ...row,
        // normalize items arrays into the common keys generatePDF looks for
        ipd_bill_items: row.ipd_bill_items || row.items || row.bill_items || row.otitems || row.services || [],
        // pass payments explicitly (use returned payments, not state)
        transactions: Array.isArray(payments) ? payments : []
      };

      await generatePDF(enriched);
    } catch (err) {
      console.error('Error preparing PDF', err);
      toast.error('Failed to prepare bill print');
    }
  }}
>
  IPD Final Bill Print
</button>


          {/* <button className="btn btn-sm btn-success" onClick={() => generateProvisionalBill({ ...row })}>Provisional Bill</button> */}
          <button className="btn btn-sm btn-warning" onClick={() => generateGatePass({ ...row })}>Gate Pass</button>
          <button className="btn btn-sm btn-primary" onClick={() => handleMoveToIpd(row)}>Move to IPD</button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      width: '380px'
    }
  ], [formData.l1, formData.wards, formData.doc, transactionHistory]);

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f1f5fb',
        color: '#405189',
        fontSize: '15px',
        fontWeight: '700',
        paddingLeft: '14px',
        paddingRight: '14px',
      }
    },
    rows: {
      style: {
        fontSize: '16px',
        minHeight: '58px',
      },
    },
    cells: {
      style: {
        paddingLeft: '14px',
        paddingRight: '14px',
        fontSize: '15px',
        lineHeight: '20px'
      }
    },
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="card" id="orderList">
          <div className="card-header border-0">
            <div className="row align-items-center gy-3">
              <div className="col-sm"><h5 className="card-title mb-0">Discharge Patient List</h5></div>
              <div className="col-sm-auto">
                <div className="d-flex gap-1"></div>
              </div>
            </div>
          </div>

          <div className="card-body border border-dashed border-start-0 border-end-0">
            <div className="row g-3">
              <div className="col-md-2">
                <label>From</label>
                <input type="date" className="form-control" value={formData.from || ''} onChange={(e) => setFormData(prev => ({ ...prev, from: e.target.value }))} />
              </div>
              <div className="col-md-2">
                <label>To</label>
                <input type="date" className="form-control" value={formData.to || ''} onChange={(e) => setFormData(prev => ({ ...prev, to: e.target.value }))} />
              </div>
              <div className="col-md-4">
                <label>Search</label>
                <div style={{display:'flex', gap:8}}>
                  <input
                    className="form-control"
                    placeholder="Search by Patient Name..."

                    value={formData.search_key}
                    onChange={(e) => handleSearchInputChange(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); doImmediateSearch(); } }}
                  />
                  <button className="btn btn-info" onClick={handleClear}>Clear</button>
                </div>
              </div>
            </div>
          </div>

          <div className="card-body pt-2">
            <div className="table-responsive table-card mb-1">
              <DataTable
                columns={columns}
                data={filteredRows}

                pagination
                highlightOnHover
                persistTableHead
                progressPending={loading}
                customStyles={customStyles}
                noHeader
                defaultSortFieldId={8}   // 🔥 Discharge Date/Time column index
                defaultSortAsc={false} 
              />
            </div>
            <div className="d-flex justify-content-end"></div>
          </div>
        </div>

        <DelBox />
      </div>
    </div>
  );
};

export default DisList;
